import React from 'react';

import { IconProps, SvgIcon } from './SvgIcon';

export const RadioUnchecked = (props: IconProps = {}): JSX.Element => {
  const { ...rest } = props;

  return (
    <SvgIcon name="RadioUnchecked" {...rest}>
      <circle cx="12" cy="12" r="11" stroke="currentColor" strokeWidth="2" />
    </SvgIcon>
  );
};
